module.exports = __webpack_public_path__ + "static/img/box-bg1.b594a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/box-bg1.png
// module id = hgPZ
// module chunks = 0